module.exports = __webpack_public_path__ + "img/1520318017.5e73fff5.jpg";